<template>
  <div class="banner" :class="[model ? model.background : '']">
    <div class="container mx-auto flex flex-col items-center lg:max-w-[940px]">
      <div class="w-full" :class="model.textColor ? model.textColor : 'text-[color:var(--color-body-text)]'">
        <div class="mb-8 text-3xl font-bold lg:text-5xl">
          {{ model.heroTitle }}
        </div>

        <div class="mb-8 flex w-full">
          <VcImage class="h-full max-h-[450px] w-full rounded-lg object-cover" :src="model.heroHeaderImage" />
        </div>

        <div class="w-full">
          <div class="mb-8 text-[20px] font-semibold leading-9" v-html-safe="model.heroSubtitle"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  model: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped>
.banner {
  min-height: 700px;
}
.hero-ups div:before {
  content: "";
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  margin: 0 1rem;
  background-color: var(--color-secondary);
}
</style>
